// import React, { useRef, useEffect, useState } from "react";
// import { AiFillPrinter } from 'react-icons/ai';
// import styled from 'styled-components';
// import ReactToPrint from "react-to-print";
// import TextareaAutosize from 'react-textarea-autosize';
// import { Img, Label, currency } from "../utilities/Shared";

// export const Wrapper = styled.div`
//   padding: 10px 20px;
//   font-size: .8rem;
//   font-weight: bold;
//   text-transform: capitalize;
//   width: 13in;
//   height: 10in;
//   box-sizing: border-box;
//   margin: 0 auto;
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-start;
//   overflow: hidden; /* Prevent content overflow */
//   @media print {
//     width: 13in;
//     height: 10in;
//     margin: 0;
//     padding: 10px 20px;
//     page-break-before: always;
//     page-break-after: avoid; /* Prevent extra page breaks */
//     page-break-inside: avoid; /* Ensure no internal breaks */
//     @page {
//       size: 13in 10in;
//       margin: 0;
//     }
//   }
// `;

// export const Input = styled.input`
//   position: ${props => props.position || "relative"};
//   width: ${props => props.width || "90%"};
//   padding: ${props => props.padding || "5px 3px 0px 3px"};
//   max-width: ${props => props.maxWidth || "100%"};
//   margin: ${props => props.margin || "0px 0px 0px 0px"};
//   height: ${props => props.height || ""};
//   font-size: ${props => props.fontSize || ".8rem"};
//   text-align: ${props => props.textalign || "center"};
//   font-weight: ${props => props.fontWeight || "bold"};
//   outline: none;
//   border: none;
//   border-bottom: 1px solid grey;
//   border-radius: 5px;
//   :focus {
//     border: 2px solid var(--plsGreen);
//   }
// `;

// export const Flexed = styled.div`
//   width: ${props => props.width || "100%"};
//   display: flex;
//   text-align: ${props => props.textAlign || ""};
//   justify-content: ${props => props.justifycontent || "flex-end"};
//   align-items: ${props => props.alignItems || "flex-start"};
//   position: ${props => props.position || "relative"};
//   padding: ${props => props.padding || "3px 0px"};
//   bottom: ${props => props.bottom || ""};
//   font-size: ${props => props.fontSize || ""};
//   margin: ${props => props.margin || ""};
//   border-bottom: ${props => props.borderBottom || ""};
// `;

// export const Flex = styled.div`
//   width: ${props => props.width || "100%"};
//   position: ${props => props.position || "relative"};
//   flex: ${props => props.flex || "1"};
//   white-space: ${props => props.whiteSpace || "nowrap"};
//   border-bottom: ${props => props.border ? "1px solid black" : ""};
//   text-align: ${props => props.textAlign || "left"};
//   padding: ${props => props.padding || "0"};
//   font-size: ${props => props.fontSize || ""};
//   h2 {
//     margin: 0;
//     padding: 0;
//   }
// `;

// export const Textarea = styled(TextareaAutosize)`
//   height: 300px; /* Reduced height to fit content */
//   max-height: 300px;
//   width: 100%;
//   outline: none;
//   text-align: ${props => props.textAlign || "left"};
//   border: 1px solid #c8c8c8;
//   font-size: 1.5rem;
//   margin: ${props => props.margin || "0"};
//   resize: none;
//   font-weight: bold;
//   border-bottom: 1px solid black;
//   :focus {
//     border: 2px solid var(--plsGreen);
//   }
// `;

// export const Headerspan = styled.div`
//   width: 100%;
//   text-align: center;
//   font-size: 1.1rem;
// `;

// export default function PrintComponent({ poinfo, savepo }) {
//   let componentRef = useRef();
//   const [message, setMessage] = useState("");
//   const [total, setTotal] = useState(0);

//   useEffect(() => {
//     const addit = () => {
//       let u = 0;
//       poinfo?.items?.map(item => {
//         u += parseFloat(item.extprice);
//       });
//       setTotal(u);
//     };
//     addit();
//   }, [poinfo]);

//   useEffect(() => {
//     const getpoinfo = async () => {};
//     getpoinfo();
//   }, []);

//   function percentage(partialValue, totalValue) {
//     const t = (partialValue / 100) * totalValue;
//     return t + totalValue;
//   }

//   console.log(poinfo);
//   console.log(total);

//   return (
//     <>
//       <Flex id="print_component">
//         <ReactToPrint
//           trigger={() => <AiFillPrinter style={{ fontSize: "calc(1.4rem + .5vw)" }} />}
//           content={() => componentRef}
//         />
//         <Flex style={{ display: "none" }}>
//           <ComponentToPrint poinfo={poinfo} total={total} ref={(el) => (componentRef = el)} />
//         </Flex>
//       </Flex>
//     </>
//   );
// }

// class ComponentToPrint extends React.Component {
//   constructor(props) {
//     super(props);
//   }

//   render() {
//     return (
//       <Wrapper>
//         <Flexed style={{ width: '100%', margin: '20px 20px 0px 20px' }}>
//           <Flex fontSize="4.5rem" flex="1" style={{ margin: "50px 0px 0px 80px", lineHeight: '4.5rem' }}>
//             Outside<br /> Services
//           </Flex>
//           <Flex flex="1" style={{ marginTop: "10px" }}>
//             <Flexed>
//               <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
//                 Date Due Back To PLS Print :
//               </Flex>
//               <Flex flex=".5" fontSize="1.4rem">
//                 09/27/2025
//               </Flex>
//             </Flexed>
//             <Flexed>
//               <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
//                 PO # :
//               </Flex>
//               <Flex flex=".5" fontSize="1.4rem">
//                 123456
//               </Flex>
//             </Flexed>
//             <Flexed>
//               <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
//                 PLS Print Job# :
//               </Flex>
//               <Flex fontSize="1.4rem" flex=".5">
//                 107585
//               </Flex>
//             </Flexed>
//             <Flexed>
//               <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
//                 Quote# :
//               </Flex>
//               <Flex fontSize="1.4rem" flex=".5">
//                 44896
//               </Flex>
//             </Flexed>
//             <Flexed>
//               <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
//                 Outside Service Vendor :
//               </Flex>
//               <Flex flex=".5" fontSize="1.4rem">
//                 CFP
//               </Flex>
//             </Flexed>
//             <Flexed>
//               <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
//                 Contact :
//               </Flex>
//               <Flex flex=".5" fontSize="1.4rem">
//                 Mark
//               </Flex>
//             </Flexed>
//           </Flex>
//         </Flexed>

//         <Flexed style={{ margin: '20px 20px 0px 20px', width: '100%' }}>
//           <Flex style={{ display: "flex", flexDirection: "column", flex: '.7', marginTop: '20px' }}>
//             <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
//               <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} checked="checked" />
//               <span style={{ fontSize: '1.5rem' }}>P.O. Enclosed</span>
//             </Flexed>
//             <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
//               <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} />
//               <span style={{ fontSize: '1.5rem' }}>Proof's Enclosed</span>
//             </Flexed>
//             <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
//               <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} />
//               <span style={{ fontSize: '1.5rem' }}>Samples Enclosed</span>
//             </Flexed>
//             <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
//               <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} />
//               <span style={{ fontSize: '1.5rem' }}>Die(s) Provided / to be made</span>
//             </Flexed>
//             <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
//               <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} />
//               <span style={{ fontSize: '1.5rem' }}>Press Check Required</span>
//             </Flexed>
//           </Flex>
//           <Flex flex='1.5' style={{ margin: '0px 20px 0px 0px' }}>
//             <div style={{ fontSize: "1.8rem" }}>* Notes *</div>
//             <div style={{ width: '100%' }}>
//               <Textarea minRows={8} textAlign='left' maxRows={8} defaultValue="Please return proofs and 25 samples with the job" />
//             </div>
//           </Flex>
//         </Flexed>
//         <Flexed>
//           <Flex flex='.7'></Flex>
//           <Flex style={{ margin: '0px 20px 0px -20px' }} fontSize="1.5rem" textAlign="center">
//             PLEASE CALL IF ANY QUESTIONS (727) 573-1763<br />Jeff or Eddie
//           </Flex>
//         </Flexed>
//         <Flexed style={{ position: 'absolute', bottom: '10px', width: '100%' }} textAlign="center">
//           <Flex fontSize="1.5rem" textAlign="center">
//             --- Please return all proofs & samples provided back to PLS Print in this envelope ---<br />
//             --- Please return all dies if provided ---
//           </Flex>
//         </Flexed>
//         <div style={{ position: 'absolute', bottom: '5px', right: '10px' }}>PLS/OSENV 9/25 R2</div>
//       </Wrapper>
//     );
//   }
// }






import React, { useRef, useEffect, useState } from "react";
import { AiFillPrinter } from 'react-icons/ai';
import styled from 'styled-components';
import ReactToPrint from "react-to-print";
import TextareaAutosize from 'react-textarea-autosize';
import { Img, Label, currency } from "../utilities/Shared";

export const Wrapper = styled.div`
  padding: 10px 20px;
  font-size: .8rem;
  font-weight: bold;
  text-transform: capitalize;
  width: 12.7in;
  height: 9in;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  @media print {
    width: 12.7in;
    height: 9in;
    margin: 0;
    padding: 10px 20px;
    page-break-before: always;
    page-break-after: avoid;
    page-break-inside: avoid;
    @page {
      size: 13in 10in;
      margin: 0;
    }
  }
`;

export const Input = styled.input`
  position: ${props => props.position || "relative"};
  width: ${props => props.width || "90%"};
  padding: ${props => props.padding || "5px 3px 0px 3px"};
  max-width: ${props => props.maxWidth || "100%"};
  margin: ${props => props.margin || "0px 0px 0px 8px"};
  height: ${props => props.height || ""};
  font-size: ${props => props.fontSize || ".8rem"};
  text-align: ${props => props.textalign || "left"};
  font-weight: ${props => props.fontWeight || "bold"};
  outline: none;
  border: none;
  border-bottom: 1px solid grey;
  border-radius: 5px;
  :focus {
    border: 2px solid var(--plsGreen);
  }
`;

export const Flexed = styled.div`
  width: ${props => props.width || "100%"};
  display: flex;
  text-align: ${props => props.textAlign || ""};
  justify-content: ${props => props.justifycontent || "flex-end"};
  align-items: ${props => props.alignItems || "flex-start"};
  position: ${props => props.position || "relative"};
  padding: ${props => props.padding || "3px 0px"};
  bottom: ${props => props.bottom || ""};
  font-size: ${props => props.fontSize || ""};
  margin: ${props => props.margin || ""};
  border-bottom: ${props => props.borderBottom || ""};
`;

export const Flex = styled.div`
  width: ${props => props.width || "100%"};
  position: ${props => props.position || "relative"};
  flex: ${props => props.flex || "1"};
  white-space: ${props => props.whiteSpace || "nowrap"};
  border-bottom: ${props => props.border ? "1px solid black" : ""};
  text-align: ${props => props.textAlign || "left"};
  padding: ${props => props.padding || "0"};
  font-size: ${props => props.fontSize || ""};
  h2 {
    margin: 0;
    padding: 0;
  }
`;

export const Textarea = styled(TextareaAutosize)`
  height: 300px;
  max-height: 300px;
  width: 100%;
  outline: none;
  text-align: ${props => props.textAlign || "left"};
  border: 1px solid #c8c8c8;
  font-size: 1.5rem;
  margin: ${props => props.margin || "0"};
  resize: none;
  font-weight: bold;
  border-bottom: 1px solid black;
  :focus {
    border: 2px solid var(--plsGreen);
  }
`;

export const Headerspan = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.1rem;
`;

export default function PrintComponent({ formData, savepo }) {
  let componentRef = useRef();
  const [message, setMessage] = useState("");
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const addit = () => {
      let u = 0;
      formData?.items?.map(item => {
        u += parseFloat(item.extprice);
      });
      setTotal(u);
    };
    addit();
  }, [formData]);

  useEffect(() => {
    const getpoinfo = async () => {};
    getpoinfo();
  }, []);

  function percentage(partialValue, totalValue) {
    const t = (partialValue / 100) * totalValue;
    return t + totalValue;
  }

  console.log(formData);
  console.log(total);

  return (
    <>
      <Flex id="print_component">
        <ReactToPrint
          trigger={() => <AiFillPrinter style={{ fontSize: "calc(1.4rem + .5vw)" }} />}
          content={() => componentRef}
        />
        <Flex style={{ display: "none" }}>
          <ComponentToPrint formData={formData} total={total} ref={(el) => (componentRef = el)} />
        </Flex>
      </Flex>
    </>
  );
}

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { formData, total } = this.props;
    const formatDate = (date) => {
      return date ? new Date(date).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }) : '';
    };

    return (
      <Wrapper>
        <Flexed style={{ width: '100%', margin: '20px 20px 0px 20px' }}>
          <Flex fontSize="4.7rem" flex="1" style={{ margin: "80px 0px 0px 80px", lineHeight: '4.5rem' }}>
            Outside<br /> Services
          </Flex>
          <Flex flex="1" style={{ marginTop: "10px" }}>
            <Flexed>
              <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
                Date Due Back To PLS Print :
              </Flex>
              <Flex flex=".5" fontSize="1.4rem">
                {formatDate(formData.dateDue || new Date())}
              </Flex>
            </Flexed>
            <Flexed>
              <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
                PO # :
              </Flex>
              <Flex flex=".5" fontSize="1.4rem">
                {formData.poNumber}
              </Flex>
            </Flexed>
            <Flexed>
              <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
                PLS Print Job# :
              </Flex>
              <Flex fontSize="1.4rem" flex=".5">
                {formData.jobNumber}
              </Flex>
            </Flexed>
            <Flexed>
              <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
                Quote# :
              </Flex>
              <Flex fontSize="1.4rem" flex=".5">
                {formData.quoteNumber}
              </Flex>
            </Flexed>
            <Flexed>
              <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
                Outside Service Vendor :
              </Flex>
              <Flex flex=".5" fontSize="1.4rem">
                {formData.vendor}
              </Flex>
            </Flexed>
            <Flexed>
              <Flex fontSize="1.4rem" textAlign="right" style={{ paddingRight: "10px" }}>
                Contact :
              </Flex>
              <Flex flex=".5" fontSize="1.4rem">
                {formData.contact}
              </Flex>
            </Flexed>
          </Flex>
        </Flexed>

        <Flexed style={{ margin: '40px 20px 0px 20px', width: '100%' }}>
          <Flex style={{ display: "flex", flexDirection: "column", flex: '.7', marginTop: '20px',paddingRight:'8px'}}>
            <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
              <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} checked={formData.checkboxes.poEnclosed} />
              <span style={{ fontSize: '1.5rem' }}>P.O. Enclosed</span>
            </Flexed>
            <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
              <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} checked={formData.checkboxes.proofsEnclosed} />
              <span style={{ fontSize: '1.5rem' }}>Proof's Enclosed</span>
            </Flexed>
            <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
              <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} checked={formData.checkboxes.samplesEnclosed} />
              <span style={{ fontSize: '1.5rem' }}>Samples Enclosed</span>
            </Flexed>
            <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
              <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} checked={formData.checkboxes.diesProvided} />
              <span style={{ fontSize: '1.5rem' }}>Die(s) Provided / to be made</span>
            </Flexed>
            <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.4rem" padding="4px 0">
              <input type="checkbox" style={{ width: "1.5rem", height: "1.5rem", marginRight: "8px" }} checked={formData.checkboxes.pressCheckRequired} />
              <span style={{ fontSize: '1.5rem' }}>Press Check Required</span>
            </Flexed>
           <Flexed alignItems="center" justifycontent="flex-start" fontSize="1.3rem" padding="5px 0">
                    
                      <span style={{ fontSize: '1.3rem' }}>Items Enclosed are Accurate</span>
                         <Input
                         width="60%"
                          value={formData.initials}
                          fontSize="1.3rem"
                        />
                    </Flexed>
          </Flex>
          <Flex flex='1.5' style={{ margin: '0px 20px 0px 0px' }}>
            <div style={{ fontSize: "1.8rem" }}>* Notes *</div>
            <div style={{ width: '100%' }}>
              <Textarea minRows={8} textAlign='left' maxRows={8} value={formData.notes} />
            </div>
          </Flex>
        </Flexed>
        <Flexed>
          <Flex flex='.7'></Flex>
          <Flex style={{ margin: '0px 20px 0px -20px' }} fontSize="1.5rem" textAlign="center">
            PLEASE CALL IF ANY QUESTIONS (727) 573-1763<br />Jeff or Eddie
          </Flex>
        </Flexed>
        <Flexed style={{ position: 'absolute', bottom: '20px', width: '100%' }} textAlign="center">
          <Flex fontSize="1.5rem" textAlign="center">
            --- Please return all proofs & samples provided back to PLS Print in this envelope ---<br />
            --- Please return all dies if provided ---
          </Flex>
        </Flexed>
        <div style={{ position: 'absolute', bottom: '15px', right: '20px' }}>PLS/OSENV 9/25 R2</div>
      </Wrapper>
    );
  }
}





